@let mcpApprovalRequest = message().content.at(0);
@if(mcpApprovalRequest && mcpApprovalRequest.type === "mcp_approval_request"){
<div class="mcp-approval-card">
  <div class="mcp-approval-header">
    <i class="pi pi-bolt"></i>
    <span>Tool <strong>{{capitalize(mcpApprovalRequest.name)}}</strong></span>
    <span class="mcp-server-badge">{{mcpApprovalRequest.server_label}}</span>
  </div>

  <details
    class="mcp-approval-details"
    [attr.open]="this.messageApprovalDone() ? null : ''"
  >
    <summary>Eingabe anzeigen</summary>
    <pre class="mcp-approval-args">{{jsonParse(mcpApprovalRequest.arguments) | json}}</pre>
  </details>

  @if(!this.messageApprovalDone()) {
  <div class="mcp-approval-actions">
    <button
      [disabled]="this.blockButtons"
      class="btn btn-primary btn-sm"
      (click)="this.mcpApprovalResponse(true)"
    >Zulassen</button>
    <button
      [disabled]="this.blockButtons"
      class="btn btn-outline-secondary btn-sm"
      (click)="this.mcpApprovalResponse(false)"
    >Überspringen</button>
  </div>
  } @else {
  <div
    class="mcp-approval-result"
    [class.approved]="this.wasApproved()"
  >
    <i [class]="this.wasApproved() ? 'pi pi-check-circle' : 'pi pi-minus-circle'"></i>
    <span>{{this.wasApproved() ? 'Zugelassen' : 'Übersprungen'}}</span>
  </div>
  }
</div>
}